import {
  UniqueSellingPropositionsApiModel,
  UniqueSellingPropositionsModel,
} from './courseUniqueSellingPropositions.model';

export const mapCourseUniqueSellingPropositions = ({
  data,
}: UniqueSellingPropositionsApiModel): UniqueSellingPropositionsModel =>
  data.map((apiUSP) => apiUSP.title);
